<template>
    <v-container>
        <v-toolbar rounded="" color="secondary" dense class="mb-3" elevation="1">
            <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Accounts Payable'} ,{text: 'Payment',}]" large/>
        </v-toolbar>
        <v-row>
            <v-col cols="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Payment Mode
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-simple-table v-if="!loading">
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{{data ? data.text : null}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <div v-else class="pa-4">
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Accounts
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="handleCreate" v-if="data && hasPermission(perm.payment_account.create)">
                            <v-icon left>mdi-plus</v-icon>
                            add account
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-data-table
                        :headers="headers"
                        :items="data && data.accounts ? data.accounts : []"
                        dense
                        hide-default-footer
                        :loading="loading"
                        disable-pagination
                        disable-sort
                        >
                        <template v-slot:[`item.actions`]="{item}">
                            <v-btn icon @click="handleDelete(item)" v-if="hasPermission(perm.payment_account.delete)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import PAlert from './../../components/common/PAlert.vue';

export default {
    name: "PurchasePaymentModeDisplayView",
    components: {
        PAlert
    },
    data() {
        return {
            id: null,
            data: null,
            loading: false,
            perm: permissions,
            headers: [
                { text: "Account", value: "display_name" },
                { text: "", value: "actions" }
            ],
            alert: {
                title: "Alert",
                content: "Are you sure?",
                value: false,
                callback: null
            }
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            find: "purchase/paymentMode/find",
            removeAccount: "purchase/paymentMode/removeAccount",
            snackbar: "ui/snackbar/show"
        }),
        handleCreate() {
            this.$router.push({ name: "PurchasePaymentModeAccountCreate", params: { id: this.id } });
        },
        handleDelete(row) {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to remove this account from payment mode?", callback: this.removeAccountAsync(row)}
        },
        removeAccountAsync(row) {
            return () => {
                this.removeAccount({paymentMode: this.id, ledgerAccountId: row.id}).then(() => {
                    this.snackbar({ text: "Account deleted", color: "success" });
                    this.fetch();
                }).catch((error) => {
                    let message = error.response ? error.response.data.message : error.message;
                    this.snackbar({ color: "error", text: message });
                });
            }  
        },
        fetch() {
            this.loading = true;
            this.find(this.id).then(response => {
                this.data = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetch();
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.fetch();
        next();
    }
}
</script>

<style>

</style>